import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";
import { PasswordInput } from "../components/PasswordInput";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) { setError("La password deve avere almeno 8 caratteri"); return; }
    if (password !== confirm) { setError("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6] p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-brand rounded-xl p-3 text-white"><KeyRound className="w-7 h-7" /></div>
          <div>
            <h1 className="font-display text-3xl font-bold">Nuova password</h1>
            <p className="text-neutral-600 text-base">Scegli una nuova password sicura</p>
          </div>
        </div>
        {done ? (
          <div className="bg-white p-6 rounded-xl border-2 space-y-4">
            <div className="flex items-center gap-2 text-green-700 font-bold text-lg"><CheckCircle2 className="w-6 h-6" /> Password aggiornata</div>
            <p className="text-base text-neutral-700">La tua password è stata reimpostata correttamente.</p>
            <Button data-testid="reset-goto-login" onClick={() => navigate("/login")} className="w-full h-12 bg-brand hover:bg-brand-dark text-white font-bold">Vai all'accesso</Button>
          </div>
        ) : !token ? (
          <div className="bg-white p-6 rounded-xl border-2 text-base text-red-800 font-semibold">Link non valido: token mancante. Richiedi un nuovo reset.</div>
        ) : (
          <form onSubmit={submit} className="space-y-4 bg-white p-6 rounded-xl border-2">
            <div>
              <Label className="text-base font-semibold">Nuova password</Label>
              <PasswordInput data-testid="reset-password" value={password} onChange={(e) => setPassword(e.target.value)}
                required className="h-14 text-lg mt-1.5" placeholder="almeno 8 caratteri" />
            </div>
            <div>
              <Label className="text-base font-semibold">Ripeti la password</Label>
              <PasswordInput data-testid="reset-confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                required className="h-14 text-lg mt-1.5" placeholder="••••••••" />
            </div>
            {error && <div data-testid="reset-error" className="p-4 bg-red-50 border-2 border-red-200 text-red-800 rounded-lg text-base font-semibold">{error}</div>}
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full h-14 text-lg font-bold bg-brand hover:bg-brand-dark text-white">
              {loading ? <Loader2 className="w-6 h-6 animate-spin" /> : "Reimposta password"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
